import store from '@/store'
import { EventBus } from '@/event-bus/event-bus.js'

export default class ProjectApi {
  static async deleteOrganisation (item) {
    return await store.dispatch('organisations/deleteOrganisation', item)
  }

  static async deleteProject (item) {
    return await store.dispatch('project/deleteProject', item)
  }

  static async updateProject (item) {
    await store.dispatch('project/updateProject', item)
  }

  static async createProject (item, setProject = true) {
    const id = await store.dispatch('project/createProject', item)
    if (setProject) {
      EventBus.$emit('set-project', { id })
    }
    return id
  }

  static async updateOrganisation (item) {
    return await store.dispatch('organisations/updateOrganisation', item)
  }

  static async createOrganisation (item) {
    return await store.dispatch('organisations/createOrganisation', item)
  }
}
